angular.module('impactx.basket').controller('OrderLimitErrorDialogCtrl',  ['$mdDialog', '$scope', 'TranslationService', 'dataGen', 'data', OrderLimitErrorDialogCtrl]);

function OrderLimitErrorDialogCtrl($mdDialog, $scope, TranslationService, dataGen, data)
{
    $scope.data = data;
    $scope.abortLabel = TranslationService.get("abort");
    $scope.adjustLabel = TranslationService.get("adjust");

    this.cancel = function () {
        $mdDialog.cancel();
    };

    this.adjust = function () {
        $mdDialog.hide();
    };

}